import { spacing } from "@layout";
import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  container: {
    cursor: "pointer",
    userSelect: "none",
  },
  row: {
    alignItems: "center",
  },
  radio: {
    marginRight: spacing.s,
  },
  label: {
    fontWeight: 500,
    marginTop: -2.5,
  },
};
